export const topContent: HTMLElement | null = document.querySelector('.main--first-content');

export const topAside: HTMLElement | null = document.querySelector('.main--first-content > aside');

export const topBanner: HTMLElement | null = topAside
  ? topAside.querySelector('.sidebar-content--top')
  : null;

export const bottomContent: HTMLElement | null = document.querySelector('.main--second-content');

export const bottomAside: HTMLElement | null = document.querySelector(
  '.main--second-content > aside'
);

export const repeaterAddSelector = 'button[data-sidebar-recount]';
